/**
 * Pesos utilizados no cálculo do primeiro dígito verificador.
 * Aplicado sobre os 12 primeiros caracteres do CNPJ normalizado.
 * Conforme IN RFB nº 2.229/2024.
 */
export const PESOS_DV1: readonly number[] = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

/**
 * Pesos utilizados no cálculo do segundo dígito verificador.
 * Aplicado sobre os 13 primeiros caracteres do CNPJ normalizado (12 base + DV1).
 * Conforme IN RFB nº 2.229/2024.
 */
export const PESOS_DV2: readonly number[] = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

/**
 * Calcula um dígito verificador de acordo com o algoritmo módulo 11
 * definido pela IN RFB nº 2.229/2024.
 *
 * O valor numérico de cada caractere é obtido por `charCode - 48`, que mapeia:
 * - '0'–'9'  →  0–9
 * - 'A'–'Z'  →  17–42
 *
 * O dígito é calculado como:
 * - `soma = Σ (valor(caractere[i]) × pesos[i])`
 * - `resto = soma % 11`
 * - `DV = (resto < 2) ? 0 : 11 - resto`
 *
 * @param sequencia - Sequência de caracteres já normalizada (maiúscula, sem máscara)
 *                    usada no cálculo. Deve ter comprimento igual a `pesos.length`.
 * @param pesos     - Array de pesos correspondente ao tamanho da sequência.
 * @returns O dígito verificador calculado (0–9).
 */
export function calcularDigitoVerificador(
  sequencia: string,
  pesos: readonly number[],
): number {
  let soma = 0;
  for (let i = 0; i < pesos.length; i++) {
    soma += (sequencia.charCodeAt(i) - 48) * pesos[i];
  }
  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
}
